import { Alert, Button } from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router';

interface IXSifterNotApprovedProps {

}

const XSifterNotApproved: React.FC<IXSifterNotApprovedProps> = (props: IXSifterNotApprovedProps) => {
    const navigate = useNavigate();
    return (
        <>
            <h1>Account not yet approved</h1>
            <Alert severity='warning'>
                Your account requires approval from Texifter Inc.
            </Alert>
            <p>
                Your account has been created but requires manual approval.
            </p>
            <p>
                If you have not heard back within two business days, please contact us via the <a href="https://xsifter.com" target='_blank'>XSifter website</a>.
            </p>
            <p>
                <Button variant="outlined" onClick={() => { navigate("/")}}>Return home</Button>
            </p>
        </>
    );
};

export default XSifterNotApproved;
